import React, { useState, useRef } from 'react'

import { getListingFacetNames, mostFacets } from 'helpers/listingHelpers'

import SectionWithExpand from './components/SectionWithExpand'
import { expandSectionHandler } from './helpers'
import GridContainer from '../GridContainer'
import GridItem from '../GridItem'

/** @type {import("./types").default} */
const FeaturesIntegrations = ({
  isCtaFullWidth = false,
  isCtaTextButton = false,
  listings,
  section,
  category,
  isMobileTabletLayout = false,
}) => {
  const [expanded, setExpanded] = useState(false)
  const ref = useRef(null)

  return (
    <GridContainer className="FeaturesIntegrations" ref={ref}>
      {listings.map((listing, index) => (
        <GridItem data-testid={`${category}-section`} key={`${category}-content-${listing.id}`}>
          <SectionWithExpand
            category={category}
            isCtaFullWidth={isCtaFullWidth}
            isCtaTextButton={isCtaTextButton}
            listingNames={getListingFacetNames(listing, category)}
            listingsNames={section}
            isHighest={mostFacets(listings, listing, category)}
            gridIndex={index}
            gridSize={listings.length}
            expanded={expanded}
            onExpandButtonClick={() => {
              expandSectionHandler(expanded, setExpanded, ref)
            }}
            href={listing.cta_urls[category]}
            isMobileTabletLayout={isMobileTabletLayout}
          />
        </GridItem>
      ))}
    </GridContainer>
  )
}

export default FeaturesIntegrations
